import styled from 'styled-components';
import AbstractTextElement from 'UIComponents/elements/AbstractTextElement';
const BigText = styled(AbstractTextElement).withConfig({
  displayName: "BigText",
  componentId: "sc-11lrp8h-0"
})(["&&{font-size:16px;line-height:28px;}"]);
export default BigText;